import React, {useContext} from 'react';
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fab,
  FormControl,
  IconButton,
  TextField,
  Tooltip
} from "@mui/material";
import {withStyles} from "@mui/styles";
import {UserContext} from "../auth/UserProvider";

const styles = () => ({
  paper: {
    maxWidth: '90%',
    margin: 'auto',
    marginTop: '2rem',
    overflow: 'hidden',
  },
  toolbar: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  block: {
    display: 'block',
  },
  contentWrapper: {
    margin: '16px 16px',
  },
  fab: {
    position: 'absolute',
    bottom: '2rem',
    right: '2rem',
  },
});

function AddLocationDialog(props) {
  const { classes, confirmationHandler, action = 'create', entity } = props;
  const [name, setName] = React.useState('');
  const [lat, setLat] = React.useState('');
  const [lng, setLng] = React.useState('');
  const [open, setOpen] = React.useState(false);

  const authState = useContext(UserContext);

  const handleClickOpen = () => {
    setOpen(true);
    setName(entity && entity.englishName ? entity.englishName : '');
    setLat(entity && entity.lat ? entity.lat : '');
    setLng(entity && entity.lng ? entity.lng : '');
  };

  const handleClose = () => {
    setOpen(false);
    setName('');
    setLat('');
    setLng('');
  };

  const handleConfirm = () => {
    action === 'create' ?
      confirmationHandler(name, lat, lng) :
        confirmationHandler(entity.id, name, lat, lng);
    handleClose();
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleLatChange = (event) => {
    setLat(event.target.value);
  };

  const handleLngChange = (event) => {
    setLng(event.target.value);
  };

  return (
      <div>
        { action === 'create' &&
          <Fab
              variant="extended"
              size="medium"
              color="secondary"
              aria-label="add"
              onClick={handleClickOpen}
              className={classes.fab}
              style={{position: 'fixed', marginBottom: '1rem'}}
          >
            <AddIcon sx={{ fontSize: 24 }}/>
            Add location
          </Fab>
        }
        { action === 'edit' && authState && authState.role && authState.role === 'ROLE_SUPER' &&
          <Tooltip title="Edit">
            <IconButton aria-label="edit"
                        onClick={handleClickOpen}>
              <EditIcon sx={{ fontSize: 24, color: 'black' }} />
            </IconButton>
          </Tooltip>
        }
        <Dialog fullWidth={true} maxWidth={'xs'} className={classes.dialog} open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{ action !== 'edit' ? 'Add' : 'Edit'} location</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter the location details
            </DialogContentText>
            <div>
              <FormControl className={classes.formControl}>
                <TextField
                    autoFocus
                    margin="normal"
                    id="name"
                    label="Name"
                    type="text"
                    value={name}
                    onChange={handleNameChange}
                    fullWidth
                />
              </FormControl>
            </div>
            <div>
              <FormControl className={classes.formControl}>
                <TextField
                    autoFocus={false}
                    margin="normal"
                    id="lat"
                    label="Latitude"
                    type="number"
                    value={lat}
                    inputProps={{
                      step: "0.01"
                    }}
                    onChange={handleLatChange}
                    fullWidth
                />
              </FormControl>
            </div>
            <div>
              <FormControl className={classes.formControl}>
                <TextField
                    autoFocus={false}
                    margin="normal"
                    id="lng"
                    label="Longitude"
                    type="number"
                    value={lng}
                    inputProps={{
                      step: "0.01"
                    }}
                    onChange={handleLngChange}
                    fullWidth
                />
              </FormControl>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleConfirm} color="primary">
              { action !== 'edit' ? 'Create' : 'Edit'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
  );
}

export default withStyles(styles)(AddLocationDialog)